import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
// SPDX-License-Identifier: AGPL-3.0-only
import { useContext } from "react";
import { useQuery } from "@apollo/client";
import { CircularProgress, Typography } from "@mui/material";
import { Dialog } from "@sequentech/ui-essentials";
import { useTranslation } from "react-i18next";
import { GET_DOCUMENT_PASSWORD } from "@/queries/DocumentPassword";
import { AuthContext } from "@/providers/AuthContextProvider";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { IPermissions } from "@/types/keycloak";
import { DecryptHelp, PasswordDialog } from "@/components/election-event/export-data/PasswordDialog";
export var reportDecryptionCommand = "openssl enc -d -aes-256-cbc -in <encrypted_file> -out <decrypted_file> -pass pass:<password> -md md5";
/** Also supports older encrypted reports which have no saved document password. */
export var ReportPasswordDialog = function (_a) {
    var _b;
    var documentId = _a.documentId, access = _a.access, onClose = _a.onClose;
    var t = useTranslation().t;
    var tenantId = useTenantStore()[0];
    var auth = useContext(AuthContext);
    var allowed = auth.isAuthorized(true, tenantId, IPermissions.DOCUMENT_PASSWORD_READ) &&
        auth.isAuthorized(true, tenantId, IPermissions.DOCUMENT_DOWNLOAD) &&
        (!(access === null || access === void 0 ? void 0 : access.voter_secret_attributes) ||
            auth.isAuthorized(true, tenantId, IPermissions.VOTER_SECRET_ATTRIBUTE_READ));
    var _c = useQuery(GET_DOCUMENT_PASSWORD, {
        variables: { documentId: documentId },
        skip: !allowed || !(access === null || access === void 0 ? void 0 : access.password_secret_id),
        fetchPolicy: "no-cache",
        context: { headers: { "x-hasura-role": IPermissions.DOCUMENT_PASSWORD_READ } },
    }), data = _c.data, loading = _c.loading, error = _c.error;
    var password = allowed ? (_b = data === null || data === void 0 ? void 0 : data.get_document_password) === null || _b === void 0 ? void 0 : _b.password : undefined;
    if (password) {
        return (_jsx(PasswordDialog, { password: password, onClose: onClose, children: _jsx(DecryptHelp, { decryptionCommand: reportDecryptionCommand }) }));
    }
    return (_jsxs(Dialog, { variant: "info", open: true, handleClose: onClose, title: String(t("reportsScreen.messages.decryptFileTitle")), ok: "Ok", children: [loading && allowed ? _jsx(CircularProgress, {}) : null, error || ((access === null || access === void 0 ? void 0 : access.password_secret_id) && !allowed) ? (_jsx(Typography, { color: "error", children: t("tasksScreen.documentAccess.passwordError") })) : null, _jsx(DecryptHelp, { decryptionCommand: reportDecryptionCommand })] }));
};
